module.exports = __webpack_public_path__ + "static/media/scarlattiLogo.a7cfed0c.svg";